<template>
  <div>
    <q-linear-progress
      v-show="isLoading"
      indeterminate
      color="primary"
    ></q-linear-progress>
    <q-card class="shadow-10-disabled flat bordered q-pa-lg">
      <q-card-section class="text-center">
        <a href="https://www.dinapsis.es/">
          <q-img
            :src="require('@/assets/img/dinapsis-color.svg')"
            alt="Dinapsis logo"
            class="center"
          />
        </a>
      </q-card-section>
      <q-card-section>
        <q-input
          ref="user"
          type="email"
          label="Correo electrónico"
          autofocus
          bottom-slots
          v-model="loginModel.email"
          @keyup.enter="submit"
          class="q-py-sm q-mb-md"
          :error="$v.loginModel.email.$error"
          lazy-rules
          :rules="[
            (val) =>
              val == '' ||
              /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(val) ||
              'Email no válido',
          ]"
        >
          <template
v-slot:error
            >Por favor escriba el correo electrónico.</template
          >
        </q-input>
        <q-input
          ref="password"
          v-model="loginModel.password"
          :type="isPwd ? 'password' : 'text'"
          label="Contraseña"
          bottom-slots
          @keyup.enter="submit"
          class="q-py-sm q-mb-lg"
          :error="$v.loginModel.password.$error"
          lazy-rules
          autocomplete="off"
        >
          <template v-slot:error>Por favor escriba la contraseña.</template>
        </q-input>
      </q-card-section>
      <q-card-actions>
        <q-btn
          @click="submit"
          class="buttonoscuro"
          style="height: 50px"
          :loading="isLoading"
          >Aceptar</q-btn
        >
      </q-card-actions>
      <q-card-actions>
        <q-btn
@click="registrarse"
class="buttonoscuro"
style="height: 50px"
          >Registrarse</q-btn
        >
      </q-card-actions>
      <div style="text-align: center">
        <br />
        <router-link
to="RecordarPassword"
          >¿Olvidaste tu contraseña?</router-link
        >
      </div>
    </q-card>
  </div>
</template>

<script>
import { required, email } from 'vuelidate/lib/validators';
import { Cookies, QImg } from 'quasar';
import axios from 'axios';
export default {
  components: {
    QImg
  },
  name: 'suez-login',
  created () {
    Cookies.remove('_id');
  },
  props: {
    isDebugMode: {
      default: true,
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      isLoading: false,
      isPwd: true,
      loginModel: {}
    };
  },
  validations: {
    loginModel: {
      email: { required, email },
      password: { required }
    }
  },
  methods: {
    registrarse () {
      this.$router.push({ name: 'registro' });
    },
    submit () {
      this.isLoading = true;
      this.$v.loginModel.$touch();
      if (this.$v.loginModel.$error) {
        this.showError('Por favor, revise el formulario.');
        this.isLoading = false;
      } else {
        this.login()
          .then((resp) => {
            this.isLoading = false;
            this.$emit('login', { data: resp.data });
          })
          .catch((err) => {
            this.isLoading = false;
            this.showError(err);
          });
      }
    },
    login () {
      return new Promise((resolve, reject) => {
        axios
          .post(process.env.VUE_APP_API_URL + '/AuthService', this.loginModel)
          .then((resp) => {
            if (this.debugMode) {
              console.log('response: ' + resp.data);
            }
            if (resp.data.token === undefined) {
              if (resp.data.Token !== undefined) {
                console.log(
                  'Error en CamelCasePropertyNamesContractResolver en Global.asax en la API'
                );
              }
              throw new Error('403.1');
            } else {
              Cookies.set('_id', resp.data.token);
            }
            resolve(resp);
          })
          .catch((err) => {
            // console.log("ERROR"+err)
            var errorMessage = 'Usuario no registrado';
            switch (err.message) {
              case 'Network Error':
                errorMessage = 'Error de red';
                break;
              // Token vacío
              case '403.1':
                errorMessage = 'Usuario o contraseña incorrecta 403.1 ';
                break;
              case 'Request failed with status code 400':
                errorMessage = 'Usuario o contraseña incorrecta';
                break;
            }
            if (this.debugMode) {
              console.log('Error:' + err);
            }
            Cookies.remove('_id');
            reject(errorMessage);
          });
      });
    },
    showError (text) {
      this.$q.notify({
        message: text,
        color: 'red',
        icon: 'warning',
        timeout: 5000,
        position: 'top-right',
        progress: true,
        actions: [{ icon: 'close', color: 'white' }]
      });
    }
  }
};
</script>
<style lang="scss" scoped>
$azulHover: #225eac;
$azuloscuro: hsl(222, 58%, 13%);
$azuloclaro: #878b97;

.buttonoscuro {
  width: 100%;
  background-color: $azuloscuro !important;
  border: none;
  color: #fff;
  font-weight: 600;
  letter-spacing: 3px;
  &:hover {
    background-color: $azulHover !important;
    color: #fff;
    font-weight: 600;
  }
}

.buttonclaro {
  width: 100%;
  background-color: $azuloclaro !important;
  border: none;
  color: #fff;
  font-weight: 600;
  letter-spacing: 3px;
  &:hover {
    background-color: $azulHover !important;
    color: $azuloclaro;
    font-weight: 600;
  }
}

a {
  width: 100%;
  border: none;
  color: rgb(126, 126, 126);
  font-weight: 300;
  text-align: center;
  letter-spacing: 1px;
  &:hover {
    color: rgb(71, 70, 70);
    font-weight: 300;
  }
  &:link {
    text-decoration: none;
  }
}
</style>
